import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "config/site";
import { Twitter, Github, Linkedin } from "lucide-react";
import { Logo } from "views/common/Logo";

const footerLinks = {
    main: [
        { name: "Submit", href: "/submit" },
        { name: "Category", href: "/category" },
        { name: "Blog", href: "/blog/1" },
        { name: "Privacy", href: "/privacy" },
        { name: "Terms", href: "/terms" },
    ],
    social: [
        { name: "Twitter", href: siteConfig.links.twitter, icon: Twitter },
        { name: "GitHub", href: siteConfig.links.github, icon: Github },
        { name: "LinkedIn", href: siteConfig.links.linkedin, icon: Linkedin },
    ],
};

export const SiteFooter = () => {
    return (
        <footer className="w-full bg-gray-900 text-white">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="py-8">
                    <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                        {/* Logo and Description */}
                        <div className="flex items-center space-x-4">
                            <Logo />
                            <p className="text-sm text-gray-300">
                                Discover and submit the best AI tools and
                                products, curated and verified by our community.
                            </p>
                        </div>

                        {/* Links and Social */}
                        <div className="flex items-center space-x-6">
                            <div className="flex items-center space-x-4">
                                {footerLinks.main.map((link) => (
                                    <Link
                                        key={link.name}
                                        to={link.href}
                                        className="text-sm text-gray-300 hover:text-white transition-colors"
                                    >
                                        {link.name}
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};
